/**
 * Fusionne userProfile (AuthContext) et authUser (localStorage) pour éviter
 * un profil périmère sans roleTypes après connexion ou changement de rôle.
 */
export function readStoredAuthUser() {
  try {
    const raw = localStorage.getItem('authUser');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function normalizeRoleTypes(user) {
  if (!user) return [];
  if (Array.isArray(user.roleTypes) && user.roleTypes.length) {
    return user.roleTypes.filter((r) => typeof r === 'string' && r.trim());
  }
  if (Array.isArray(user.roles) && user.roles.length) {
    return user.roles
      .map((r) => (typeof r === 'string' ? r : r?.role_type))
      .filter((r) => typeof r === 'string' && r.trim());
  }
  if (typeof user.primaryRole === 'string' && user.primaryRole.trim()) {
    return [user.primaryRole.trim()];
  }
  if (typeof user.role === 'string' && user.role.trim()) {
    return [user.role.trim()];
  }
  return [];
}

function normalizePermissionCodes(user) {
  if (!user || !Array.isArray(user.permissionCodes)) return [];
  return user.permissionCodes.filter((c) => typeof c === 'string' && c.trim());
}

export function resolveEffectiveAuthUser(userProfile) {
  const stored = readStoredAuthUser();
  const base = userProfile || stored;
  if (!base) return null;

  const profileRoles = normalizeRoleTypes(userProfile);
  const storedRoles = normalizeRoleTypes(stored);
  const roleTypes = profileRoles.length ? profileRoles : storedRoles;

  const profilePerms = normalizePermissionCodes(userProfile);
  const storedPerms = normalizePermissionCodes(stored);
  const permissionCodes = profilePerms.length ? profilePerms : storedPerms;

  return {
    ...stored,
    ...base,
    id: base.id || stored?.id,
    roleTypes,
    permissionCodes,
  };
}
